/* Cabeçalho de seção: numeração, título e uma linha de contexto.
 *
 * O título da seção é um TÍTULO (20px, peso 600, caixa normal), não a etiqueta
 * miúda que era antes: dentro de uma célula ele é o primeiro degrau, e o que o
 * separa do texto abaixo é tamanho e peso.
 *
 * A NUMERAÇÃO SAIU DO PAINEL e continua só no laudo. Numeração ordena a
 * leitura de um DOCUMENTO, que se lê do início ao fim; o painel se lê por onde
 * a pergunta manda, e ali ela só afirmava uma ordem que ninguém segue. Pior:
 * amarrava o rótulo à posição, então mover um capítulo obrigava a renumerar os
 * outros, e o custo de reordenar a página passava a ser maior que o de
 * deixá-la errada. `numero` fica opcional para o laudo continuar usando. */
export function Cabecalho({
  numero,
  titulo,
  nota,
}: {
  numero?: string;
  titulo: string;
  nota?: string;
}) {
  return (
    <div className="mb-4 grid gap-1.5">
      <h2 className="titulo-cartao flex items-baseline gap-2">
        {numero === undefined ? null : (
          <span className="numero text-tinta-2 text-sub font-medium">
            {numero}
          </span>
        )}
        {titulo}
      </h2>
      {nota ? <p className="apoio">{nota}</p> : null}
    </div>
  );
}
